import { html } from "lit";

export const SocialMediaWallTemplate = () => {
    return html`
        <div class="ux-row">
            <div class="ux-col-12 ux-u-background-grey">
                <div
                    class="ux-row ux-u-flex-jc-center ux-u-mt-fluid-s ux-u-mb-fluid-s"
                >
                    <div class="ux-col-12 ux-col-sm-10">
                        <h2
                            class="ux-text-headline ux-text-headline--big ux-u-text-align--center
                                   ux-u-margin-bottom-15 ux-u-margin-xl-bottom-20 ux-u-margin-top-0"
                        >
                            Social Media Wall
                        </h2>
                        <ux-iws-social-media-wall
                            wall-identifier="w76gb"
                            load-more-text="mehr laden"
                        >
                            <ux-icon name="tiles-big"></ux-icon>
                            <p class="ux-text-normal">
                                Please accept the cookies to view the posts
                            </p>
                        </ux-iws-social-media-wall>
                    </div>
                </div>
            </div>
        </div>
    `;
};
